module.exports = __webpack_public_path__ + "media/images/touch/homescreen192-3ef9e0db96ec8bae83635584ddb1e35e.png";